<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica utente' : 'Nuovo utente'"
                     @back="$router.replace('/users')" @saveback="save(true)" :loading="loading"></form-header>
        <v-col cols="12" >
          <h3>Dati di accesso</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Email*"
              v-model="editingItem.email"
              type="email"
              autocomplete="off"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="3" xl="3">
          <v-select
              label="Ruolo utente*"
              :items="roles"
              v-model="editingItem.role"
              :rules="[rules.required]"
          ></v-select>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              :label="'Password' + (isEditing ? '' : '*')"
              type="password"
              v-model="editingItem.password"
              counter
              autocomplete="off"
              hint="min 6 caratteri"
              :rules="isEditing ? [] : [rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              :label="'Conferma password' + (isEditing ? '' : '*')"
              type="password"
              v-model="confirmPassword"
              autocomplete="off"
              hint="uguale alla password"
              :rules="editingItem.password ? [rules.confirmPassword(editingItem.password)]:[]"
              counter
          ></v-text-field>
        </v-col>
        <v-col cols="12" >
          <h3>Identità</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Nome*"
              v-model="editingItem.name"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Cognome*"
              v-model="editingItem.surname"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Telefono"
              v-model="editingItem.phone"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Codice fiscale"
              v-model="editingItem.fiscal_code"
              :rules="[rules.fiscal_code]"
              @update:model-value="fiscalCodeUppercaser"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Data di nascita"
              type="date"

              v-model="dateOfBirth"
          ></v-text-field>
        </v-col>

        <v-col cols="8" md="4" lg="3" xl="2">
          <v-text-field
              label="Luogo di nascita"
              v-model="editingItem.city_of_birth"
          ></v-text-field>
        </v-col>

        <v-col cols="4" md="2" lg="2" xl="1">
          <v-text-field
              label="Provincia di nascita"
              v-model="editingItem.province_of_birth"
              hint="es. PG"
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <h3>Indirizzo</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Indirizzo"
              v-model="editingItem.address.name"
              hint="Via\Piazza ..."
          ></v-text-field>
        </v-col>
        <v-col cols="8" md="4" lg="3" xl="2">
          <v-text-field
              label="Città"
              v-model="editingItem.address.city"
          ></v-text-field>
        </v-col>

        <v-col cols="4" md="2" lg="2" xl="1">
          <v-text-field
              label="Provincia"
              v-model="editingItem.address.province"
              hint="es. PG"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="CAP"
              v-model="zipCode"
          ></v-text-field>
        </v-col>




        <v-col cols="12" >
          <h3>Forma fisica</h3>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Altezza (cm)*"
              type="number"
              :step="1"
              v-model="editingItem.height"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Peso (kg)*"
              type="number"
              :step="1"
              v-model="editingItem.weight"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-select
              label="Qta di allenamento medio*"
              persistent-hint
              hint="a settimana"
              :items="trainingOptions"
              v-model="editingItem.training"
          ></v-select>
        </v-col>

        <v-col cols="12" >
          <h3>Impostazioni</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-select
              label="Tipologia utente"
              v-model="editingItem.user_type"
              :items="userTypeOptions"
              disabled
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch
              label="Sandbox user"
              v-model="editingItem.sandbox"
              persistent-hint
              hint="effettua i pagamenti su paypal sandbox (ambiente di test)"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.user_type === 'card'">
          <v-switch
              label="Accettazione responsabilità certificato medico"
              v-model="editingItem.certificate"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch
              label="Privacy policy - marketing"
              disabled
              v-model="editingItem.privacy_1"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch
              label="Privacy policy - marketing partners"
              disabled
              v-model="editingItem.privacy_2"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch
              label="Privacy policy - profilazione"
              disabled
              v-model="editingItem.privacy_3"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch
              label="Possiede Home Kit"
              v-model="editingItem.home_kit"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch
              label="Attivo"
              v-model="editingItem.active"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch
              label="Abbonamenti in pausa"
              v-model="editingItem.pause_subscription"
              :hint="`Giorni di pausa utilizzati: ${editingItem.num_pauses} di ${numDaysOfPausesAvailable}`"
              persistent-hint
          ></v-switch>
        </v-col>
        <v-col cols="12">
          <v-textarea  label="Note" v-model="editingItem.notes"></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-textarea  label="Note per l'utente" v-model="editingItem.user_notes" hint="ATTENZIONE! Queste note saranno visibili dall'utente nel frontend" persistent-hint></v-textarea>
        </v-col>

        <v-col cols="12" v-if="editingItem.user_type === 'card'">
          <v-row >
            <v-col cols="12">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <h3 class="title">Informazioni tessera CONI</h3>
            </v-col>
            <v-col cols="12" v-if="card">
              <ul>
                <li><span class="font-weight-bold">Numero tessera:</span> {{card.number}}</li>
                <li><span class="font-weight-bold">Assicurazione:</span> {{card.insurance}}</li>
                <li :class="cardExpirationClass(card.expiration)"><span class="font-weight-bold">Scadenza:</span> {{formatDate(card.expiration)}}</li>
              </ul>
            </v-col>
            <v-col v-else class="font-italic">
              Nessuna tessera presente in database.
            </v-col>

            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <h3 class="title">Documenti</h3>
            </v-col>
            <v-col cols="12" lg="6">
              <h4>Documento d'identità</h4>
              <div class="d-flex" v-if="editingItem.identity_card_front || editingItem.identity_card_rear">
                <v-btn v-if="editingItem.identity_card_front" density="compact" color="primary" @click="openPrivateLink('identityfront')">Vedi fronte</v-btn>
                <v-btn class="ml-3" v-if="editingItem.identity_card_rear" density="compact" color="primary" @click="openPrivateLink('identityrear')">Vedi retro</v-btn>
              </div>

              <span class="font-italic" v-if="!editingItem.identity_card_front && !editingItem.identity_card_rear">Nessun documento d'identità presente in database.</span>
              <v-file-input  label="Allega fronte" v-model="identityCardFront" class="mt-3"/>
              <v-file-input  label="Allega retro" v-model="identityCardRear" class="mt-3"/>
            </v-col>
            <v-col cols="12" lg="6">
              <h4>Certificato medico</h4>
              <v-btn v-if="editingItem.medical_cert" density="compact" color="primary" @click="openPrivateLink('medical')">Vedi certificato</v-btn>
              <span v-else class="font-italic">Nessun certificato medico presente in database.</span>
              <v-file-input  label="Allega certificato" v-model="medicalCert" class="mt-3"/>
              <v-text-field label="Scadenza certificato" type="date" clearable class="mt-3" v-model="medicalCertExp"/>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
              <h3 class="title">Scheda di allenamento</h3>
            </v-col>
            <v-col cols="12" lg="6">
              <v-btn v-if="editingItem.scheda" density="compact" color="primary" @click="openPrivateLink('scheda')">Vedi scheda</v-btn>
              <span v-else class="font-italic">Nessuna scheda di allenamento presente in database.</span>
              <v-file-input  label="Allega scheda" v-model="scheda" class="mt-3" />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" v-if="isEditing">
          <v-row >
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="d-flex align-center">
              <h3 class="title">Extra pause abbonamenti</h3>
              <v-btn class="ml-3" color="primary" @click="addPauseDialog = true" append-icon="mdi-plus" density="compact">Aggiungi</v-btn>
            </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <v-switch hide-details v-model="query.valid" label="Nascondi pause scadute" @change="applyFilter" ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-data-table-server
                  v-model:items-per-page="pagination.limit"
                  v-model:page="pagination.page"
                  v-model:sort-by="pagination.sort"
                  :headers="headers"
                  v-model:items-length="count"
                  :items="items"
                  :loading="tableLoading"
                  density="compact"
                  class="border"
                  no-data-text="L'utente non ha pause abbonamento extra.">
                <template v-slot:item.from="{ item }">
                  {{ formatDate(item.from) }}
                </template>
                <template v-slot:item.to="{ item }">
                  {{ formatDate(item.to) }}
                </template>
                <template v-slot:item.edit="{ item }">
                  <v-btn color="primary" variant="text" icon="mdi-pencil" v-on:click="editPause(item)"></v-btn>
                </template>
                <template v-slot:item.remove="{ item }">
                  <v-btn color="error" variant="text" icon="mdi-close" v-on:click="requestPauseDelete(item._id!)"></v-btn>
                </template>
              </v-data-table-server>
            </v-col>
          </v-row>
        </v-col>

        <form-footer @back="$router.replace('/users')" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>

    <v-dialog v-model="addPauseDialog" max-width="800" :persistent="tableLoading">
      <v-card >
        <v-form ref="pauseForm" @submit.prevent="savePause">
          <v-card-title class="text-primary">{{pauseItem._id ? 'Modifica':'Aggiungi una'}} pausa abbonamento</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="16" lg="6">
                <v-text-field type="date" v-model="pauseItemFrom" label="Valida dal" :rules="[rules.required]" ></v-text-field>
              </v-col>
              <v-col cols="16" lg="6">
                <v-text-field type="date" v-model="pauseItemTo" label="Valida fino al (non compreso)" :rules="[rules.required]" ></v-text-field>
              </v-col>
              <v-col cols="16" lg="6">
                <v-text-field type="number" v-model="pauseItem.num_days" label="Numero di giorni" :rules="[rules.required, rules.minInt(1)]" ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn variant="text" @click="addPauseDialog = false" :disabled="tableLoading" density="compact">Annulla</v-btn>
            <v-btn variant="elevated" color="primary" type="submit" :disabled="tableLoading" :loading="tableLoading" density="compact">Salva</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import config from "../config";
import rules from "../utils/rules";
import {DateTime} from "luxon";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import {type ConiCard, type ExtraSeatsPause, type Pagination, type Query, type User, UserRole} from "@/models.ts";
import {roles} from "@/consts.ts";
import api from "@/api";

export default {
  name: "UserForm",
  components: {FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()

    const form = ref<any>()
    const pauseForm = ref<any>()
    const loading = ref(false)
    const tableLoading = ref(false)
    const count = ref(0)
    const addPauseDialog = ref(false)
    const pauseItem = ref<ExtraSeatsPause>({
      from: "", num_days: 7, to: ""
    })
    const card = ref<ConiCard|undefined>()
    const scheda = ref<File|undefined>()
    const identityCardFront = ref<File|undefined>()
    const identityCardRear = ref<File|undefined>()
    const medicalCert = ref<File|undefined>()
    const medicalCertExp = ref<string|undefined>()
    const confirmPassword = ref<string|undefined>()
    const editingItem = ref<User>({
      city_of_birth: "",
      done_lessons: [],
      done_products: [],
      fiscal_code: "",
      home_kit: false,
      identity_card_front: "",
      identity_card_rear: "",
      medical_cert: "",
      num_pauses: 0,
      ongoing_lessons: [],
      ongoing_products: [],
      pause_subscription: false,
      privacy_1: false,
      privacy_2: false,
      privacy_3: false,
      province_of_birth: "",
      temp_password: "",
      user_notes: "",
      user_type: "",
      email: "",
      name: "",
      surname: "",
      role: UserRole.user,
      phone: "",
      height: 0,
      weight: 0,
      training: 0,
      address: {
        name: "",
        city: "",
        province: "",
        zip_code: ""
      },
      password: "",
      sandbox: false,
      active: true,
      certificate: false,
      scheda : '',
      notes : '',
    })

    const items = ref<ExtraSeatsPause[]>([])
    const pagination = ref<Pagination>({
      page : 0,
      sort : [],
      limit : 10,
      count : 0
    })
    const query = ref<Query>({
      valid : true
    })
    let headers:any[] = [
      { title : 'Valido dal', sortable: true, align: 'left', value : 'from' },
      { title : 'Valido fino al (non compreso)', sortable: true, align: 'left', value : 'to' },
      { title : 'N° giorni', sortable: true, align: 'left', value : 'num_days' },
      { title : 'Modifica', sortable: false, align: 'center', value : 'edit', width : 60 },
      { title : 'Rimuovi', sortable: false, align: 'center', value : 'remove', width : 60 },
    ]

    const resetPauseItem = () => {
      pauseItem.value = {
        from : '',
        to : '',
        num_days : 7
      }
      const dt =  DateTime.now().set({ month : globals.settings.value.month_of_sport_year_start, day : globals.settings.value.day_of_sport_year_start }).startOf('day')
      if(DateTime.now() < dt) {
        pauseItem.value.from = dt.minus({year : 1}).toISO()
        pauseItem.value.to = dt.toISO()
      } else {
        pauseItem.value.from = dt.toISO()
        pauseItem.value.to = dt.plus({year : 1}).toISO()
      }
    }

    const applyFilter = async () => {
      tableLoading.value = true;
      const res = await api.list<ExtraSeatsPause>('pauses', {
        ...query.value,
        user : editingItem.value._id,
      }, pagination.value.limit, pagination.value.page, utils.sortToString(pagination.value.sort))
      tableLoading.value = false;
      if(!res.success) {
        messages.error(res.message ?? Msg.serverError)
        return
      }
      count.value = res.count!
      items.value = res.data!
    }

    const loadCard = async () => {
      const res = await api.list<ConiCard>('cards', { cf : editingItem.value.fiscal_code }, 0, 0, '-expiration')
      if(res.data) {
        card.value = res.data[0];
      }
    }
    
    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<User>('users', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/users')
        return
      }
      editingItem.value = res.data!
      
      if(editingItem.value.medical_cert_expiration) {
        medicalCertExp.value = utils.toDateTime(editingItem.value.medical_cert_expiration).toISODate()!
      }

      resetPauseItem()
      await applyFilter()

      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      form,
      pauseForm,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      addPauseDialog,
      pauseItem,
      card,
      scheda,
      identityCardFront,
      identityCardRear,
      medicalCert,
      medicalCertExp,
      editingItem,
      confirmPassword,
      trainingOptions : [
        { title : "Meno di 1 giorno", value : 0},
        { title : "1 giorno", value : 1},
        { title : "2 giorni", value : 2},
        { title : "3 giorni", value : 3},
        { title : "4 giorni", value : 4},
        { title : "5 giorni", value : 5},
        { title : "6 giorni", value : 6},
        { title : "7 giorni", value : 7},
      ],
      roles,
      userTypeOptions: [
        { title: "Commerciale", value: "commercial" },
        { title: "Tesserato MSP", value: "card" }
      ],
      settings: globals.settings,
      rules: {
        fiscal_code: (value:any) => {
          if(value && utils.isValidCF(value)) {
            loadCard().then(()=>{});
            return true;
          }
          card.value = undefined;
          return "Codice fiscale non valido";
        },
        ...rules
      },
      footerProps : {
        "items-per-page-title" : "N° risultati per pagina",
        "items-per-page-options" : [10,20,50,100],
        "items-per-page" : 10
      },
      tableLoading,
      count,
      items,
      headers,
      pagination,
      query,
      numDaysOfPausesAvailable : computed(()=>{
        let num = globals.settings.value.max_days_of_subscription_pause;
        for(let i = 0; i < items.value.length; i++) {
          const pause = items.value[i];
          num += pause.num_days
        }
        return num;
      }),
      dateOfBirth : computed({
        get() {
          if(!editingItem.value.date_of_birth) return undefined;
          const dt = DateTime.fromISO(editingItem.value.date_of_birth);
          if(!dt || !dt.isValid) return undefined;
          return dt.toISODate();
        },
        set(newVal:string|undefined) {
          if(!newVal) {
            editingItem.value.date_of_birth = undefined;
            return;
          }
          const dt = DateTime.fromISO(newVal)
          if(!dt || !dt.isValid) {
            editingItem.value.date_of_birth = undefined;
            return;
          }
          editingItem.value.date_of_birth = dt.toISO()
        }
      }),
      pauseItemFrom : computed({
        get() {
          if(!pauseItem.value.from) return undefined;
          const dt = DateTime.fromISO(pauseItem.value.from);
          if(!dt || !dt.isValid) return undefined;
          return dt.toISODate();
        },
        set(newVal:string|undefined) {
          if(!newVal) {
            pauseItem.value.from = '';
            return;
          }
          const dt = DateTime.fromISO(newVal)
          if(!dt || !dt.isValid) {
            pauseItem.value.from = '';
            return;
          }
          pauseItem.value.from = dt.toISO()
        }
      }),
      pauseItemTo : computed({
        get() {
          if(!pauseItem.value.to) return undefined;
          const dt = DateTime.fromISO(pauseItem.value.to);
          if(!dt || !dt.isValid) return undefined;
          return dt.toISODate();
        },
        set(newVal:string|undefined) {
          if(!newVal) {
            pauseItem.value.to = '';
            return;
          }
          const dt = DateTime.fromISO(newVal)
          if(!dt || !dt.isValid) {
            pauseItem.value.to = '';
            return;
          }
          pauseItem.value.to = dt.toISO()
        }
      }),
      zipCode : computed({
        get():string {
          return editingItem.value.address.zip_code
        },
        set( value:string ) {
          editingItem.value.address.zip_code = value;

          let cap = parseInt(value, 10);

          if (Number.isNaN(cap)) {
            editingItem.value.user_type = 'commercial';
            console.log("commercial");
            return
          }

          if(cap >= 5010 && cap <= 5100) {
            //terni
            editingItem.value.user_type = 'card';
            console.log("card");
            return
          }
          if(cap >= 6010 && cap <= 6089) {
            //perugia
            editingItem.value.user_type = 'card';
            console.log("card");
            return
          }
          if(cap >= 6121 && cap <= 6135) {
            //perugia 2
            editingItem.value.user_type = 'card';
            console.log("card");
            return
          }
          console.log("comm");
          editingItem.value.user_type = 'commercial';
        }
      }),
      applyFilter,
      resetPauseItem,
      async savePause() {
        const v = await pauseForm.value.validate()
        if(!v.valid) return;
        tableLoading.value = true;
        pauseItem.value.user_id = editingItem.value._id;
        //pauseItem.value.from = DateTime.fromISO(pauseItem.value.from).startOf("day").toJSON()
        //pauseItem.value.to = DateTime.fromISO(pauseItem.value.to).startOf("day").toJSON()
        pauseItem.value.num_days = utils.toInt(pauseItem.value.num_days, 1);
        const res = await api.save<ExtraSeatsPause>('pauses', pauseItem.value)
        tableLoading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          return
        }
        await applyFilter()
        resetPauseItem();
        addPauseDialog.value = false
      },
      editPause( item:ExtraSeatsPause ) {
        pauseItem.value = {
          _id : item._id,
          from : DateTime.fromISO(item.from)!.toISODate()!,
          to : DateTime.fromISO(item.to)!.toISODate()!,
          user_id : item.user_id,
          num_days : item.num_days,
        }
        addPauseDialog.value = true
      },
      requestPauseDelete(id:string) {
        messages.requestConfirm("Richiesta conferma", "Sei sicuro di voler eliminare questa pausa extra di abbonamento?", false,  async ok =>
        {
          if(!ok) return
          const res = await api.del('pauses', id)
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
            return
          }
          resetPauseItem()
        })
      },
      fiscalCodeUppercaser() {
        if(editingItem.value.fiscal_code) {
          editingItem.value.fiscal_code = editingItem.value.fiscal_code.toUpperCase();
        }
      },
      cardExpirationClass( date:string ) {
        if(utils.toDateTime(date) < DateTime.now()) {
          return "text-error";
        }
        return "text-success";
      },
      formatDate : utils.formatDate,
      openPrivateLink( fileType:string ) {
        window.open(`${config.apiServer}/api/users/${editingItem.value._id}/${fileType}?t=${localStorage.token}`, '_blank')
      },
      async save(goBackAfterSave:boolean) {
        const v = await form.value.validate()
        if(!v.valid) return;

        loading.value = true;

        if(!medicalCertExp.value || !DateTime.fromISO(medicalCertExp.value).isValid) {
          editingItem.value.medical_cert_expiration = undefined
        } else {
          editingItem.value.medical_cert_expiration = DateTime.fromISO(medicalCertExp.value).toISO()!
        }

        editingItem.value.training = utils.toInt(editingItem.value.training, 0)
        editingItem.value.weight = utils.toInt(editingItem.value.weight, 0)
        editingItem.value.height = utils.toInt(editingItem.value.height, 0)

        const res = await api.save<User>('users', editingItem.value)
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        const id = res.data!._id;
        if(identityCardFront.value) {
          let formData = new FormData();
          formData.append("file", identityCardFront.value);
          const res = await api.upload<User>(`users/${id}/identityfront`, formData)
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
          } else {
            editingItem.value = res.data!
          }
        }
        if(identityCardRear.value) {
          let formData = new FormData();
          formData.append("file", identityCardRear.value);
          const res = await api.upload<User>(`users/${id}/identityrear`, formData)
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
          } else {
            editingItem.value = res.data!
          }
        }

        if(medicalCert.value) {
          let formData = new FormData();
          formData.append("file", medicalCert.value);
          const res = await api.upload<User>(`users/${id}/medical`, formData)
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
          } else {
            editingItem.value = res.data!
          }
        }
        if(scheda.value) {
          let formData = new FormData();
          formData.append("file", scheda.value);
          const res = await api.upload<User>(`users/${id}/scheda`, formData)
          if(!res.success) {
            messages.error(res.message ?? Msg.serverError)
          } else {
            editingItem.value = res.data!
          }
        }
        await globals.refresh('users')
        loading.value = false;
        messages.success("Utente salvato")
        if(goBackAfterSave) {
          await router.replace('/users')
        } else if(route.params.id === 'new'){
          await router.replace(`/users/${editingItem.value._id}`)
        }


      }
    };
  }
};
</script>

<style scoped></style>
